import React from 'react';
import { ChevronDownIcon as HeroChevronDownIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type ChevronDownIconProps = Omit<IconProps, 'children'>;

export const ChevronDownIcon: React.FC<ChevronDownIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroChevronDownIcon />
        </Icon>
    );
};
